export const LockDimensionsStates = {
    UNLOCKED: "UNLOCKED",
    LOCKED_WITH_NEW_ADD: "LOCKED_WITH_NEW_ADD",
    LOCKED: "LOCKED",
} as const;
export type LockDimensionsStates = (typeof LockDimensionsStates)[keyof typeof LockDimensionsStates];
